(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rg-product-bundles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rg-component-offer')) {
    customElements.define('rg-component-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.querySelector('form').addEventListener('submit', (event) => this.addOffer(event));
      }

      async addOffer(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.pending) return;
        this.pending = true;
        const button = this.querySelector('button');
        const status = this.querySelector('[role="alert"]');
        const cartLink = this.querySelector('.rg-bundle-card__cart-link');
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.hidden = true;
        cartLink.hidden = true;
        let added = false;

        try {
          const cartResponse = await fetch(this.dataset.cartUrl + '.js', {credentials: 'same-origin'});
          if (!cartResponse.ok) throw new Error(this.dataset.error);
          const cart = await cartResponse.json();
          const codes = (cart.discount_codes || []).map((entry) => entry.code).filter(Boolean);
          for (const application of cart.cart_level_discount_applications || []) {
            if (application.type === 'discount_code') codes.push(application.title);
          }
          for (const item of cart.items || []) {
            for (const allocation of item.line_level_discount_allocations || []) {
              if (allocation.discount_application?.type === 'discount_code') {
                codes.push(allocation.discount_application.title);
              }
            }
          }
          const items = Array.from(this.querySelectorAll('input[name$="[id]"]')).map((input) => ({id: Number(input.value), quantity: 1}));
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          added = true;
          const discounts = [...new Set([...codes, this.dataset.discount])].join(',');
          const discountResponse = await fetch(this.dataset.updateUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({discount: discounts})
          });
          if (!discountResponse.ok) throw new Error(this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          if (added) {
            window.location.assign(this.dataset.discountUrl);
            return;
          }
          status.textContent = error.message || this.dataset.error;
          status.hidden = false;
          cartLink.hidden = false;
          this.pending = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
